import React from 'react'
import Docm from './Docm';


function DocumentsCard({ documentDetails, building, handle, tenant, soldgala, investor }) {
    var sortedData = [];
    setTimeout(() => {
        document.getElementsByClassName('react-carousel-responsive__root')[0]?.removeAttribute("style")
        document.getElementsByClassName('react-carousel-responsive__track')[0]?.removeAttribute("style")
    }, 1000);
    if (documentDetails?.length > 0) {
        if (tenant == true || soldgala == true || investor == true) {
            if (investor == true) {
                documentDetails.map((images) => {
                    if (images.view == 0) {
                        sortedData.push({ documentname: images.documentname, documenturl: images.documenturl, id: images.id })
                    }
                })
            } else {
                documentDetails.map((images) => {
                    sortedData.push({ documentname: images.documentname, documenturl: images.documenturl, id: images.id })
                })
            }
        } else {
            documentDetails.map((images) => {
                images.documenturl.map((url) => {
                    if (url.view == 0) {
                        sortedData.push({ documentname: images.documentname, documenturl: url.url })
                    }
                })
            })
        }
    }


    const deleteDocument = (data) => {
        handle(data.id)
    }

    return (
        <>
            <div className="documents-cards gap-3 w-100">
                {sortedData && <Docm list={sortedData} building={tenant == true || soldgala == true || investor == true ? true : false} deleteDocument={deleteDocument} />}
            </div>

        </>
    )
}

export default DocumentsCard